import { CommonResponse } from '@gtpl/shared-models/masters';
import { RmReWeighingResponse } from '@gtpl/shared-models/raw-material-procurement';
import { Injectable } from '@nestjs/common';
import { IndentItemRequest } from './dto/indent-item-id.request';
import { ReWeighingItemsDto } from './dto/re-weighed-items.dto';
import { ReWeighIdRequest } from './dto/re-weighing-id.request';
import { ReWeighingAdapter } from './dto/re-weighing.adapter';
import { ReWeighingDto } from './dto/re-weighment.dto';
import { RMReWeighingRepository } from './rm-re-weighing.repository';

@Injectable()
export class RmReWeighingService {
    constructor(private repository: RMReWeighingRepository, private adapter: ReWeighingAdapter) { }
    async createRmReWeighing(rmWeighingData: ReWeighingItemsDto): Promise<CommonResponse> {
        for (const data of rmWeighingData.rmItemWeighData) {
            const convertedData = await this.adapter.convertDtoToEntity(data);
            const savedData = await this.repository.save(convertedData);
        }
        return new CommonResponse(true, 1111, 'Created successfully');
    }

    async getRmReWeighingData(req: IndentItemRequest): Promise<RmReWeighingResponse> {
        const data = await this.repository.find({ where: { indentItemId: req.indentItemId, isActive: true } });
        if (data) {
            return new RmReWeighingResponse(true, 9999, 'No Data Found', data);
        } else {
            return new RmReWeighingResponse(false, 9999, 'No Data Found');
        }
    }

    async deleteReWeighItem(req: ReWeighIdRequest): Promise<CommonResponse> {
        const data = await this.repository.update({ rmReWeighingId: req.rmReWeighingId }, { isActive: false });
        if (data.affected) {
            return new CommonResponse(true, 9999, 'Successfully Removed', data);
        } else {
            return new CommonResponse(false, 9999, 'Failed to Delete');
        }
    }
}
